export const RbdmClubListSchema = {
	title: 'RBDM Club List schema',
	description: 'create a RBDM Club List schema',
	version: 1,
	primaryKey: 'sfid',
	type: 'object',
	properties: {
		id: { type: 'number' },
		sfid: { type: 'string', primary: true, maxLength: 200 },
		name: { type: 'string' },
		assigned_cmdi: { type: ['string', 'null'] },
	},
	required: ['id', 'name', 'sfid', 'assigned_cmdi'],
};
